(function () {
	'use strict';

	angular.module('dcApp').directive('listvalue', [
		'$parse',
		function ($parse) {
			var controller = [
				'$scope',
				'$rootScope',
				function ($scope, $rootScope) {
					$scope.deleteListValueItem = function (index) {
						$scope.listValue.splice(index, 1);
					};

					$scope.addListValueItem = function (index) {
						$scope.listValue.push($scope.typeCannotBeCreated ?
							$scope.getDefaultFirstColumn() : ''
						);
					};

					var vm = this;

					$scope.getMatchingColumns = function (columns, type) {
						let cols = [];
						for (let c in columns) {
							if (columns[c].type === type) {
								// colId depends on whether the rule is used for a datablock or an entity
								// We assume that if there is a UUID, we are in datablock case
								let columnId = columns[c].uuid
									? columns[c].uuid
									: columns[c].id;
								let isDbRule = columns[c].uuid != null;
								let filteredCol = {
									columnLib: columns[c].lib,
									columnId: columnId,
									isColumn: true,
									isDbRule: isDbRule,
								};
								cols.push(filteredCol);
							}
						}
						return cols;
					};

					$scope.getDefaultFirstColumn = function () {
						return $scope.getMatchingColumns(
							$scope.columns,
							$scope.selectedRule.filter
								? $scope.selectedRule.filter.type
								: $scope.selectedRule.type
						)[0];
					}

					$scope.showValueSelectColumn = function (index) {
						$scope.listValue[index] = $scope.getDefaultFirstColumn();
						$scope.listValue[index].isColumn = true;
					};

					$scope.hideValueSelectColumn = function (index) {
						$scope.listValue[index] = undefined;
					};
					$scope.save = function () {
						$scope.vm.widgetData.listValue = $scope.listValue;
						vm.widgetData.updateaction_l2();
						closeModal();
					};

					$scope.cancel = function () {
						closeModal();
					};

					$scope.getDateTimeWithPatternFilter =
						$rootScope.getDateTimeWithPatternFilter;

					function closeModal() {
						$(vm.element).modal('hide');
						vm.widgetData.showListValueFilter = false;
					}
				},
			];

			return {
				restrict: 'E',

				scope: {
					widgetData: '=',
					saveAction: '&',
				},
				controller: controller,
				controllerAs: 'vm',
				bindToController: true,
				templateUrl:
					'./src/components/directives/dataOperationTools/listValueFilter/listValueFilter.html',
				transclude: true,
				replace: true,
				link: function postLink(scope, element, attrs) {
					$(element).modal({
						show: false,
						keyboard: attrs.keyboard,
						backdrop: attrs.backdrop,
					});
					$(element).on('hidden.bs.modal', function () {
						scope.$apply(function () {
							scope.vm.widgetData.showListValueFilter = false;
						});
					});
					scope.$watch(
						function () {
							return scope.vm.widgetData.showListValueFilter;
						},
						function (value) {
							scope.vm.element = element;
							if (value === true) {
								scope.listValue = scope.vm.widgetData.listValue;
								scope.selectedRule = scope.vm.widgetData.selectedRule;
								scope.columns = scope.vm.widgetData.columns;
								// If element type cannot be created here, only show select columns
								scope.typeCannotBeCreated =
									scope.selectedRule.filter.type == 'file' ||
									scope.selectedRule.type == 'file';
								if (!scope.listValue) {
									scope.listValue = [];
									scope.listValue.push(scope.typeCannotBeCreated ?
											scope.getDefaultFirstColumn() : ''
									);
								}
								$(element).modal('show');
							} else {
								$(element).modal('hide');
							}
						}
					);
				},
			};
		},
	]);
})();
